export default __webpack_public_path__ + "static/media/engineering.12280386.png";